module.exports = __webpack_public_path__ + "static/media/picto-notifs.ab0fa20e.svg";